const getDomain = () => {
  let brands = ["very.ie", "veryie", "very", "littlewoodsireland", "littlewoods", "localhost"];

  let currentBrand = brands.filter((brand) => {
    return window.location.hostname.indexOf(brand) !== -1;
  });

  switch (currentBrand[0]) {
    case "very.ie":
      return "https://www.very.ie";
    case "veryie":
      return "https://www.very.ie";
    case "very":
      return "https://www.very.co.uk";
    case "localhost":
      return "http://localhost:8080";
    case "littlewoods":
      return "https://www.littlewoods.com";
    case "littlewoodsireland":
      return "https://www.littlewoodsireland.ie";
    default:
      break;
  }
};
export default getDomain;
